export default __webpack_public_path__ + "static/media/fm.9b826793.svg";